import { Box, Typography } from '@mui/material';
import { TreeViewCollapseIcon, TreeViewExpandIcon } from '@mui/x-tree-view/icons';
import { KeyboardEvent, SyntheticEvent } from 'react';

export const tinyLabelSx = {
    fontSize: '10px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
};

export const tinySelectSx = {
    fontSize: '10px',
    height: 22,
    minWidth: 80,
    maxWidth: 140,
    flexGrow: 1,
};

export const sliderRowSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
    minWidth: 0,
};

export const optionalSliderLabelSx = {
    whiteSpace: 'nowrap',
};

export const sliderSx = {
    flex: '1 1 0',
    minWidth: 0,
};

export const sliderUnitSx = {
    ml: 0.5,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    flex: '0 0 auto',
};

export const formatOneDecimal = (value: number) => value.toFixed(1);
export const formatTwoDecimals = (value: number) => value.toFixed(2);

const stopSliderPointerPropagation = (event: SyntheticEvent) => {
    event.stopPropagation();
};

const stopSliderKeyPropagation = (event: KeyboardEvent) => {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
        event.stopPropagation();
    }
};

export const sliderInteractionProps = {
    onMouseDown: stopSliderPointerPropagation,
    onPointerDown: stopSliderPointerPropagation,
    onKeyDown: stopSliderKeyPropagation,
};

interface CollapsibleGroupLabelProps {
    label: string;
    open: boolean;
    onToggle: () => void;
}

export const CollapsibleGroupLabel: React.FC<CollapsibleGroupLabelProps> = ({ label, open, onToggle }) => (
    <Box
        onClick={onToggle}
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
            mb: 0.5,
            cursor: 'pointer',
            userSelect: 'none',
        }}
    >
        <Box sx={{ display: 'inline-flex', alignItems: 'center', color: 'text.secondary', flex: '0 0 auto' }}>
            {open ? <TreeViewCollapseIcon sx={{ fontSize: '0.95rem' }} /> : <TreeViewExpandIcon sx={{ fontSize: '0.95rem' }} />}
        </Box>

        <Typography
            sx={{
                fontSize: '8px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'text.secondary',
                whiteSpace: 'nowrap',
            }}
        >
            {label}
        </Typography>

        <Box
            sx={{
                flexGrow: 1,
                height: '1px',
                bgcolor: 'divider',
                opacity: 0.3,
            }}
        />
    </Box>
);
